import { createContext, useContext } from "react";

interface ServerStyleContextData {
  key: string;
  ids: string[];
  css: string;
}

const ServerStyleContext = createContext<null | ServerStyleContextData[]>(null);

const useServerStyleContext = () => {
  return useContext(ServerStyleContext);
};

export { ServerStyleContext, useServerStyleContext, type ServerStyleContextData };
